<template>
  <v-row class="newsMessage pa-0 ma-0 d-flex justify-end">
    <v-col cols="12" class="d-flex justify-center align-center ">
      <h2 class="color-title">{{ t(titleN) }}</h2>
    </v-col>

    <div class="w-100 d-flex justify-center align-center" v-if="newsData && (!newsData.news || newsData.news.length === 0)">
      <p class="font-h5 color-alt">- {{ t('暫無資料') }} -</p>
    </div>
    <v-col cols="12" class="content-all" v-if="newsData && newsData.news && newsData.news.length > 0">
      <ol class="newsOl">
        <li v-for="(item, index) in newsData.news"
        v-show="index < pieceP"
        :key="index">
          <a class="content w-100 ma-0"
            @click="$router.push({ path: '/newsContent', 
            params: { url: item.newsurl,title:'最新消息'}, 
            query:{msg_ID:item.msg_ID,pool_ID:newsData.pool_ID}})  
              newtest(item)"
            :href="'/newsContent?msg_ID=' + item.msg_ID + '&pool_ID=' + newsData.pool_ID"
            :title="t(item.newstitle)"
            target="_self"
          >
            <v-row class="pa-0 ma-0 w-100 d-flex pt-3 justify-start">
              <!-- 日期 -->
              <v-col cols="12" md="1" class="d-flex justify-start align-center color-alt pa-0 ma-0"
               :class="isMobile? 'app-newsDate':'pc-newsDate'">
                <div class="mon"
                :class="isMobile? 'font-p':'font-h6'">
                  {{ item.newsdate[5] + item.newsdate[6] }}
                </div>
                <div :class="isMobile? 'color-alt font-p':'hr'">{{ isMobile? '/':'' }}</div>
                <div class="day"
                :class="isMobile? 'font-p':'font-h4'">
                  {{ item.newsdate[8] + item.newsdate[9] }}
                </div>
              </v-col>

              <v-col cols="12" md="11" class="px-0 pl-md-3 pt-1 pt-md-3 ma-0">
              <!-- 內容 -->
                <v-row class="pa-0 ma-0 d-flex w-100 justify-start align-center">
                  <v-col cols="11" md="11" class="pa-0 ma-0">
                    <!-- 左側內容 -->
                    <v-row class="pa-0 ma-0">
                      <!-- 拆上下 -->
                      <v-col cols="12" class="pa-0 ma-0">
                        <p class="textline-1 font-B ma-0 color-black text-justify">
                          {{ t(item.newstitle) }}
                        </p>
                      </v-col>

                      <v-col cols="12" class="pa-0 ma-0 d-flex justify-center align-center">
                        <div class="d-flex justify-center align-center ma-0 mr-2 ml-1 bullhorn">
                          <i class="fa-solid fa-bullhorn color-alt"></i>
                        </div>
                        <p class="font-h6 textline-1 pa-0 mr-1 pt-1 ma-0 color-alt text-justify">{{ t(item.newcontent) }}</p>
                      </v-col>

                    </v-row>
                  </v-col>

                  <!-- 看更多icon -->
                  <v-col cols="1" class="icon14-primary d-flex justify-center align-center news-icon-right">
                    <i class="font-B fa-solid fa-arrow-right color-alt"></i>
                  </v-col>

                </v-row>
              </v-col>
            </v-row>
          </a>
        </li>
      </ol>
    </v-col>
    <v-col cols="12" class="d-flex justify-end align-center" v-if="newsData && newsData.news && newsData.news.length > 0">
      <a class="ma-2 color-btn font-B rounded-pill icon16"
          :href="moreurlData.url"
          :title="`更多最新消息`">
        {{ t('more') }}
        <i class="ml-2 fa-solid fa-angles-right"></i>
      </a>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import axios from "axios";

export default {
  name: "App",
  props: ["titleName", "piece", "news", "moreurl", "previousPageUrl"],
  data() {
    return {
      //more會連去哪
      moreurlData: "",
      //最新消息內容
      newsData: "",
      //標題
      titleN: "",
      //則數
      pieceP: "",
      //上一頁
      previousPage: ""
    };
  },
  methods: {
    newtest(item) {
      var self = this;
      document.getElementById("pageTitle").innerHTML =
        self.$store.state.deptName + "-" + item.newstitle;
    }
  },
  created() {
    var head = document.getElementsByTagName("head")[0];
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://kit.fontawesome.com/cd51d51391.js"; //要載入的js
    head.appendChild(script);
  },
  mounted() {
    var self = this;
    self.titleN = self.titleName;
    self.pieceP = self.piece;
    self.moreurlData = self.moreurl;
    self.previousPage = self.previousPageUrl;
  },
  watch: {
    titleName: function() {
      var self = this;
      self.titleN = self.titleName;
    },
    piece: function() {
      var self = this;
      self.pieceP = self.piece;
    },
    news: function() {
      var self = this;
      self.newsData = self.news;
    },
    moreurl: function() {
      var self = this;
      self.moreurlData = self.moreurl;
    },
    previousPageUrl: function() {
      const self = this;
      self.previousPage = self.previousPageUrl;
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    ...mapState(["poolId", "colorAll"])
  }
};
</script>

<style lang="scss" scope>
.newsOl{
  list-style-type: none;
  padding-left: 0px !important; /* 取消左側縮排 */
  li{
    border-bottom: 2px var(--get-color-primary-l) dotted;
  }
}
.bullhorn{
  width: 1em;
  height: 1em;
  i{
    font-size: 0.8889em;
  }
}

.news-icon-right{
  font-size: 1.1111em;
  width: 50px ;
}
.content:hover{
  .pc-newsDate{
    opacity: 1;
  }
  .color-primary{
    color: var(--get-color-primary-d);
  }
  .color-black{
    color: var(--primary);
  }
  .color-alt{
    color: var(--te-black);
    font-weight: bold;
  }
  .news-icon-right{
    .color-alt{
      color: var(--primary);
    }
  }
}
.content:focus-within{
  .pc-newsDate{
    opacity: 1;
  }
  .color-primary{
    color: var(--get-color-primary-d);
  }
  .color-black{
    color: var(--primary);
  }
  .color-alt{
    color: var(--te-black);
    font-weight: bold;
  }
  .news-icon-right{
    .color-alt{
      color: var(--primary);
    }
  }
}
.pc-newsDate{
  position: relative;
  max-width: 70px !important;
  opacity: 0.5;
  .mon{
    position: absolute;
    top: 5%;
    left: 10%;
  }
  .hr{
    width: 2px;
    height: 70%;
    transform: rotate(45deg);
    background-color: var(--alt);
    position: absolute;
    top: 5%;
    left: 35%;
  }
  .day{
    position: absolute;
    bottom: 5%;
    right: 5%;
  }
}

</style>
